import React, { useEffect } from 'react';
import { useFormStore } from '../../state/FormStore';
import { t } from '../../utils/i18n';

export const Toolbar = () => {
    const setActive = useFormStore(state => state.setActive); // Get the setActive function from the Zustand store
    const activeTab = useFormStore(state => state.activeTab); // Get the activeTab from the Zustand store
    const { formData } = useFormStore();

    // Check if we're in standalone doors mode
    const isStandaloneDoors = formData?.purchase_mode?.mode_option === 'Standalone Doors Only';

    const allMenuItems = [
        { label: 'purchase_mode', title: 'Purchase Mode' },
        { label: 'maat', title: 'Maat' },
        { label: 'uitval_type', title: 'Uitval Type' },
        { label: 'kleur', title: 'Kleur' },
        { label: 'dak', title: 'Dak' },
        { label: 'zonwering', title: 'Zonwering' },
        { label: 'verlichting', title: 'Verlichting' },
        { label: 'gutter', title: 'Gutter' },
        { label: 'voorkant', title: 'Voorkant' },
        { label: 'linker', title: 'Linker' },
        { label: 'rechter', title: 'Rechter' }
    ];

    // Filter menu items based on purchase mode
    const menuItems = isStandaloneDoors
        ? allMenuItems.filter(item => ['purchase_mode', 'maat', 'kleur', 'voorkant', 'linker', 'rechter'].includes(item.label))
        : allMenuItems;

    // Function to handle tab click and set active state
    const handleTabClick = tabName => {
        setActive(tabName);
    };

    useEffect(() => {
        const rootFieldsetIds = [
            'purchase_mode', 'maat', 'uitval_type', 'kleur', 'dak', 
            'zonwering', 'verlichting', 'gutter', 'voorkant', 'linker', 'rechter'
        ];

        rootFieldsetIds.forEach(id => {
            const fieldset = document.querySelector(`.darzo-input #root_${id}`);
            if (fieldset) fieldset.style.display = 'none';
        });

        // Show the fieldset with the activeTab value
        const activeFieldset = document.querySelector(`.darzo-input #root_${activeTab}`);
        if (activeFieldset) {
            activeFieldset.style.display = 'block';
        }
    }, [activeTab]);

    /*     useEffect(() => {
            const rootFieldsets = document.querySelectorAll('.sub-darzo-input fieldset[id^="root_"]');
            rootFieldsets.forEach(fieldset => {
                fieldset.style.display = 'none';
            });
    
            const showSubOptions = (tab, fieldName, option, fieldsetId) => {
                if (activeTab === tab && formData?.[tab]?.[fieldName] === option) {
                    const subOptionsFieldset = document.querySelector(`.sub-darzo-input #root_${fieldsetId}`);
                    if (subOptionsFieldset && formData.maat.breedte <= 400) {
                        subOptionsFieldset.style.display = 'block';
                    }
                }
            };
    
            showSubOptions('voorkant', 'schuifdeur', 'Aluminium Schuifdeur', 'voorkant_alum_schuifdeur_options');
            showSubOptions('rechter', 'rechter_wand_option', 'Aluminium Schuifdeur', 'rechter_alum_schuifdeur_options');
            showSubOptions('linker', 'linker_wand_option', 'Aluminium Schuifdeur', 'linker_alum_schuifdeur_options');
    
        }, [activeTab, formData]);
     */




    useEffect(() => {
        // Sub Configurator
        const rootFieldsets = document.querySelectorAll('.sub-darzo-input fieldset[id^="root_"]');
        rootFieldsets.forEach(fieldset => {
            fieldset.style.display = 'none';
        });

        if (activeTab === 'voorkant' && formData?.voorkant?.schuifdeur === 'Aluminium Schuifdeur') {
            const subOptionsFieldset = document.querySelector('.sub-darzo-input #root_voorkant_alum_schuifdeur_options');
            if (subOptionsFieldset) {
                if (formData.maat.breedte <= 400) {
                    subOptionsFieldset.style.display = 'block';
                }
            }
        }
        if (activeTab === 'voorkant' && formData?.voorkant?.schuifdeur === 'Glazen Schuifdeur') {
            const subOptionsFieldset = document.querySelector('.sub-darzo-input #root_voorkant_glazen_schuifdeur_options');
            if (subOptionsFieldset) {
                subOptionsFieldset.style.display = 'block';
            }
        }
        if (activeTab === 'rechter' && formData?.rechter?.rechter_wand_option === 'Aluminium Schuifdeur') {
            const subOptionsFieldset = document.querySelector('.sub-darzo-input #root_rechter_alum_schuifdeur_options');
            if (subOptionsFieldset) {
                if (formData.maat.uitval <= 400) {
                    subOptionsFieldset.style.display = 'block';
                }
            }
        }
        if (activeTab === 'linker' && formData?.linker?.linker_wand_option === 'Aluminium Schuifdeur') {
            const subOptionsFieldset = document.querySelector('.sub-darzo-input #root_linker_alum_schuifdeur_options');
            if (subOptionsFieldset) {
                if (formData.maat.uitval <= 400) {
                    subOptionsFieldset.style.display = 'block';
                }

            }
        }


    }, [activeTab, formData]);
    return (
        <nav className="bg-gray-900 justify-between w-3/12 h-screen">
            <div className="mt-10 mb-10 text-center">
                <ul className="text-gray-500 text-xs desktop-sidemenu-main">
                    {menuItems.map(item => (
                        <li key={item.label} className={`mb-5 ${activeTab === item.label ? 'active' : ''}`}>
                            <a href="#" onClick={() => handleTabClick(item.label)}>
                                <span>
                                    <img
                                        src={`icons/${item.label}.png`}
                                        alt={item.title}
                                        className="h-6 w-6 mx-auto hover:text-green-500"
                                    />
                                </span>
                                {t(item.title)}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    );
};
